import Vue from "vue";
Vue.config.productionTip = false;

import App from "./App.vue";
import router from "./_router";
import { store } from "./_store";

// Using Font awesome and importing only the Icons needed
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebook,
  faInstagram,
  faYoutube,
  faTwitter,
  faGooglePlusG,
  faLinkedinIn,
  faSnapchatGhost,
  faWhatsapp,
  faPinterestP
} from "@fortawesome/free-brands-svg-icons";

import {
  faArrowUp,
  faArrowDown,
  faTimes,
  faEnvelope,
  faArrowRight,
  faShoppingCart,
  faGift,
  faHeadphones,
  faHeadphonesAlt,
  faCommentDots
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faFacebook,
  faInstagram,
  faYoutube,
  faTwitter,
  faGooglePlusG,
  faLinkedinIn,
  faSnapchatGhost,
  faWhatsapp,
  faPinterestP,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faTimes,
  faEnvelope,
  faShoppingCart,
  faGift,
  faHeadphones,
  faHeadphonesAlt,
  faCommentDots
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// For Boostrap and custom styles to override it
import "bootstrap";

// Using Carousel
import VueCarousel from "@chenfengyuan/vue-carousel";
Vue.use(VueCarousel);

import Vue2Filters from "vue2-filters";
var Vue2FiltersConfig = {
  currency: {
    symbol: "₦",
    spaceBetweenAmountAndSymbol: true
  }
};

Vue.use(Vue2Filters, Vue2FiltersConfig);

import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css"; //Vuesax styles
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: "#95c720"
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
import "@/assets/scss/style.scss";
import "@/assets/style.scss";
